import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsAddressWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_ADDRESS;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  ContactsAddressWUT
};
//# sourceMappingURL=contacts-address-wut.js.map
